'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagSaAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M1.20848e-05 -7.62939e-06C9.33335 3.71025e-05 18.6667 -4.29357e-05 28 8.64267e-07V20C18.6667 20 9.33334 20 0 20L1.20848e-05 -7.62939e-06Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M1.20848e-05 -7.62939e-06L28 8.64267e-07V20H0L1.20848e-05 -7.62939e-06Z",
          fill: "#128C4B"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6.66668 12H17.3333V11.0787C17.3333 10.5831 17.8549 10.2608 18.2982 10.4824L18.6667 10.6667V12H20.6667C21.0349 12 21.3333 12.2985 21.3333 12.6667V13.3333C21.3333 14.0697 20.7364 14.6667 20 14.6667H18C17.6318 14.6667 17.3333 14.3682 17.3333 14V13.3333H8.27615C8.09934 13.3333 7.92977 13.2631 7.80475 13.1381L6.66668 12Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6.66668 8.13807C6.66668 8.04966 6.7018 7.96488 6.76431 7.90237L7.09764 7.56903C7.22782 7.43886 7.22782 7.2278 7.09764 7.09763L6.76431 6.76429C6.7018 6.70178 6.66668 6.617 6.66668 6.52859V5.66666C6.66668 5.48257 6.81592 5.33333 7.00001 5.33333H7.74537C7.886 5.33333 8.00001 5.44734 8.00001 5.58797C8.00001 5.85668 8.36225 5.94219 8.48242 5.70185L8.5818 5.50309C8.63382 5.39905 8.74016 5.33333 8.85648 5.33333H10.3333C10.5174 5.33333 10.6667 5.48257 10.6667 5.66666C10.6667 5.85076 10.5174 6 10.3333 6H9.66668C9.48258 6 9.33334 6.14924 9.33334 6.33333C9.33334 6.51743 9.48258 6.66666 9.66668 6.66666H10.3333C10.5174 6.66666 10.6667 6.8159 10.6667 7V9C10.6667 9.18409 10.5174 9.33333 10.3333 9.33333H9.66668C9.48258 9.33333 9.33334 9.18409 9.33334 9V8.33333C9.33334 8.14924 9.48258 8 9.66668 8C9.85077 8 10 7.85076 10 7.66666C10 7.48257 9.85077 7.33333 9.66668 7.33333H9.00001C8.81592 7.33333 8.66668 7.48257 8.66668 7.66666V9C8.66668 9.18409 8.51744 9.33333 8.33334 9.33333C8.14925 9.33333 8.00001 9.18409 8.00001 9V8.33333C8.00001 8.14924 7.85077 8 7.66668 8C7.48258 8 7.33334 8.14924 7.33334 8.33333V9C7.33334 9.18409 7.18411 9.33333 7.00001 9.33333C6.81592 9.33333 6.66668 9.18409 6.66668 9V8.13807Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M17.3333 8.13807C17.3333 8.04966 17.3685 7.96488 17.431 7.90237L17.7643 7.56903C17.8945 7.43886 17.8945 7.2278 17.7643 7.09763L17.431 6.76429C17.3685 6.70178 17.3333 6.617 17.3333 6.52859V5.66666C17.3333 5.48257 17.4826 5.33333 17.6667 5.33333H18.412C18.5527 5.33333 18.6667 5.44734 18.6667 5.58797C18.6667 5.85668 19.0289 5.94219 19.1491 5.70185L19.2485 5.50309C19.3005 5.39905 19.4068 5.33333 19.5231 5.33333H21C21.1841 5.33333 21.3333 5.48257 21.3333 5.66666C21.3333 5.85076 21.1841 6 21 6H20.3333C20.1493 6 20 6.14924 20 6.33333C20 6.51743 20.1493 6.66666 20.3333 6.66666H21C21.1841 6.66666 21.3333 6.8159 21.3333 7V9C21.3333 9.18409 21.1841 9.33333 21 9.33333H20.3333C20.1493 9.33333 20 9.18409 20 9V8.33333C20 8.14924 20.1493 8 20.3333 8C20.5174 8 20.6667 7.85076 20.6667 7.66666C20.6667 7.48257 20.5174 7.33333 20.3333 7.33333H19.6667C19.4826 7.33333 19.3333 7.48257 19.3333 7.66666V9C19.3333 9.18409 19.1841 9.33333 19 9.33333C18.8159 9.33333 18.6667 9.18409 18.6667 9V8.33333C18.6667 8.14924 18.5174 8 18.3333 8C18.1493 8 18 8.14924 18 8.33333V9C18 9.18409 17.8508 9.33333 17.6667 9.33333C17.4826 9.33333 17.3333 9.18409 17.3333 9V8.13807Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M16 6.33021C16 6.51603 15.8958 6.77083 15.7593 6.90735L15.574 7.09265C15.4411 7.22557 15.4375 7.4375 15.574 7.57401L15.7593 7.75932C15.8923 7.89224 16 8.14269 16 8.33645V8.99688C16 9.1827 15.8573 9.33333 15.6636 9.33333H15.0031C14.8173 9.33333 14.6667 9.19064 14.6667 8.99688V8.33645C14.6667 8.15063 14.6052 8.12304 14.5121 8.30924L14.1546 9.02409C14.0692 9.19488 13.8431 9.33333 13.6698 9.33333H12.3303C12.1479 9.33333 12 9.17871 12 9C12 8.8159 12.1427 8.66667 12.3365 8.66667H12.9969C13.1827 8.66667 13.3333 8.51204 13.3333 8.33333C13.3333 8.14924 13.1907 8 12.9969 8H12.3365C12.1506 8 12 7.85662 12 7.67301V5.66032C12 5.47973 12.1427 5.33333 12.3365 5.33333H12.9969C13.1827 5.33333 13.3333 5.47602 13.3333 5.66979V6.33021C13.3333 6.51603 13.1787 6.66666 13 6.66666C12.8159 6.66666 12.6667 6.82129 12.6667 7C12.6667 7.18409 12.8094 7.33333 13.0031 7.33333H13.6636C13.8494 7.33333 14 7.17639 14 7.00307V5.66359C14 5.48119 14.1546 5.33333 14.3333 5.33333C14.5174 5.33333 14.6667 5.47602 14.6667 5.66979V6.33021C14.6667 6.51603 14.8213 6.66666 15 6.66666C15.1841 6.66666 15.3333 6.52397 15.3333 6.33021V5.66979C15.3333 5.48397 15.488 5.33333 15.6667 5.33333C15.8508 5.33333 16 5.47602 16 5.66979V6.33021Z",
          fill: "white"
        }
      )
    ]
  }
);
const VpFlagSaAsset = forwardRef(FlagSaAsset);

export { VpFlagSaAsset as default };
